import { render, staticRenderFns } from "./AddAdvertisement.vue?vue&type=template&id=6e25f15c&scoped=true"
import script from "./AddAdvertisement.vue?vue&type=script&lang=js"
export * from "./AddAdvertisement.vue?vue&type=script&lang=js"
import style0 from "./AddAdvertisement.vue?vue&type=style&index=0&id=6e25f15c&prod&lang=less&scoped=true"
import style1 from "./AddAdvertisement.vue?vue&type=style&index=1&id=6e25f15c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e25f15c",
  null
  
)

export default component.exports